import { DynamoDBClient } from '@aws-sdk/client-dynamodb'

/**
 * AWS認証情報
 * ※ 便宜上、リージョンも含めている
 */
export type AWSCredentials = {
  accessKeyId: string
  secretAccessKey: string
  sessionToken: string
  region: string
}
/**
 * AWS SDKを利用するための機能を提供する。
 */
export default function useAWS() {
  /**
   * DynamoDB クライアントを初期化して返す。
   *
   * @param awsCredentials AWS の認証情報
   */
  const initAWS = (awsCredentials: AWSCredentials) =>
    new DynamoDBClient({
      region: awsCredentials.region,
      credentials: {
        accessKeyId: awsCredentials.accessKeyId,
        secretAccessKey: awsCredentials.secretAccessKey,
        sessionToken: awsCredentials.sessionToken,
      },
    })

  return {
    initAWS,
  }
}
